<script>
import Vue from 'vue';

export default {
    provide() {
        return {
            editorProvider: this.editorProvider,
        };
    },

    props: {
        onPreviewHtml: {
            type: Function,
            default: (params, done) => {
                done({ html: params.html });
            },
        },
    },

    data() {
        return {
            editorProvider: Vue.observable({
                editor: null,
                register: this.register,
                unregister: this.unregister,
                previewHtml: this.previewHtml,
            }),
        };
    },

    methods: {
        register(editor) {
            this.editorProvider.editor = editor;
        },

        unregister() {
            this.editorProvider.editor = null;
        },

        previewHtml(params, done) {
            this.onPreviewHtml(params, done);
        },
    },

    render() {
        return this.$scopedSlots.default(this.editorProvider);
    },
};
</script>
